import { Component, inject, input } from '@angular/core';
import { TeamItemDto } from '@artemis-software/wr-api';
import { Router } from '@angular/router';

@Component({
  standalone: false,
  selector: 'wr-team-dashboard-info',
  templateUrl: './team-dashboard-info.component.html',
  styleUrls: ['./team-dashboard-info.component.scss'],
})
export class TeamDashboardInfoComponent {

  readonly team = input<TeamItemDto | undefined>();
  readonly router = inject(Router);

  editTeam(team: TeamItemDto) {
    this.router.navigate(['team', team.id]);
  }
}
